module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/success.c44b59ad.png";